export default [
    {
        type: "equals",
        label: "="
    },
    {
        type: "notEquals",
        label: "≠"
    },
    {
        type: "lessThanOrEquals",
        label: "≤"
    },
    {
        type: "lessThan",
        label: "<"
    },
    {
        type: "greaterThan",
        label: ">"
    },
    {
        type: "greaterThanOrEquals",
        label: "≥"
    },
    {
        type: "hasValue",
        label: "Is set"
    },
    {
        type: "hasEvent",
        label: "Has event"
    }
]